export const REFRESH_PAGE = "/sign_in/refresh_token";
const SIGN_IN_PAGE = "/sign_in/phone";
let navigationTarget: string | null = null;

export const saveAuthSessionValue = (key: string, value: string) => {
  // A parent effect may still persist its old state while sign out is navigating.
  if (navigationTarget !== SIGN_IN_PAGE) localStorage.setItem(key, value);
};

export const clearAuthSession = () => {
  [
    "xProfilePk", "xUserRole", "xAuthToken", "xAuthRefreshToken",
    "xShowMyClaims", "xShowNewClaims", "xNotificationsEnabled", "xLayout", "xUserAuthType",
    "xChatDrafts", "xUserPinData", "xUserPinCode", "xLastUserPk", "xFcmToken",
  ].forEach((key) => localStorage.removeItem(key));
  sessionStorage.removeItem("xUserPinEntered");
};

export const redirectToSignIn = () => {
  clearAuthSession();
  if (navigationTarget !== SIGN_IN_PAGE) {
    navigationTarget = SIGN_IN_PAGE;
    window.location.replace(SIGN_IN_PAGE);
  }
};

export const redirectToRefresh = () => {
  if (navigationTarget || window.location.pathname === REFRESH_PAGE) return;
  if (!localStorage.getItem("xAuthRefreshToken")) {
    redirectToSignIn();
    return;
  }
  navigationTarget = REFRESH_PAGE;
  window.location.replace(REFRESH_PAGE);
};
